import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  paper: {
    position: 'absolute',
    zIndex: 1,
    left: 0,
    right: 0,
  },
});

const JoinConversationMenu = ({ children, innerProps, options }) => {
  const classes = useStyles();

  if (!options.length) return null;

  return (
    <Paper square className={classes.paper} {...innerProps}>
      {children}
    </Paper>
  );
};

export default JoinConversationMenu;
